import React, { useContext } from 'react'
import View from '../../atoms/View'
import { ItemContext } from 'src/contexts/itemContext'
import { useTranslation } from 'react-i18next'
import Text from 'src/components/atoms/TextNew'
import { formatPrice } from 'src/helpers/formatPrice'

interface Props {
  viewType: 'sold' | 'archived'
}
const ArchivedPriceColumn = ({ viewType }: Props): JSX.Element => {
  const itemContext = useContext(ItemContext)
  const { t } = useTranslation()
  if (itemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }
  if (viewType === 'archived') {
    return (
      <View className="flex rounded-l-2 shadow-insetSmall bg-grey">
        <View className="w-[272px] flex flex-col items-center justify-center">
          <Text className="text-white text-xl font-SemiBold">{t('archived_date')}</Text>
          <Text className="text-white text-xl font-Bold">{itemContext.archived_at}</Text>
        </View>
      </View>
    )
  }

  if (viewType === 'sold') {
    return (
      <View className="flex rounded-l-2 shadow-insetSmall bg-grey">
        <View className="w-[272px] flex flex-col items-center justify-center">
          <Text className="text-white text-xl font-SemiBold">{t('sold')}</Text>
          <Text className="text-white text-xl font-Bold">{`€ ${formatPrice(itemContext.final_price ?? 0)}`}</Text>
        </View>
      </View>
    )
  }
  return <></>
}

export default ArchivedPriceColumn
